import React from "react";

export default function DemoInstructorPanel({
  title,
  intro,
  stepLabel,
  instruction,
  actionLabel,
  onAction,
  actionDisabled,
  onSkip,
  centered,
  placement = "bottom-right",
}) {
  const placementClass =
    placement === "top-right" ? "demo-instructor-panel--top-right" : "";
  return (
    <div
      className={`demo-instructor-panel ${
        centered ? "demo-instructor-panel--centered" : ""
      } ${placementClass}`.trim()}
    >
      <div className="demo-instructor-panel__title">{title}</div>
      {intro ? <div className="demo-instructor-panel__intro">{intro}</div> : null}
      <div className="demo-instructor-panel__step">{stepLabel}</div>
      <div className="demo-instructor-panel__instruction">{instruction}</div>
      <div className="demo-instructor-panel__actions">
        {actionLabel ? (
          <button
            type="button"
            className={`lp-btn lp-primary demo-instructor-panel__action-btn ${
              actionDisabled ? "" : "is-actionable"
            }`.trim()}
            onClick={onAction}
            disabled={actionDisabled}
          >
            {actionLabel}
          </button>
        ) : null}
        <button type="button" className="lp-btn lp-ghost" onClick={onSkip}>
          Skip Demo
        </button>
      </div>
    </div>
  );
}
